import React from 'react';
import clsx from 'clsx';
import type { EnrollmentIcon } from 'components/rtmEnrollment/enrollmentSteps';
import { getRtmEnrollmentStyles } from 'components/rtmEnrollment/rtmEnrollmentStyles';

type IconTileProps = {
  icon: EnrollmentIcon;
  size?: 'lg' | 'sm';
};

export default function IconTile({ icon: Icon, size = 'lg' }: IconTileProps) {
  const styles = getRtmEnrollmentStyles();
  const isLarge = size === 'lg';
  const tileStyles = isLarge ? styles.icon.tileLg : styles.icon.tileSm;

  const containerClassName = clsx(
    styles.icon.tileBase,
    'shrink-0',
    tileStyles.container,
  );

  const iconClassName = clsx(
    styles.icon.tileColor,
    tileStyles.icon,
  );

  return (
    <div className={containerClassName}>
      <Icon className={iconClassName} aria-hidden="true" />
    </div>
  );
}
